import {ErrorHandler, LOCALE_ID, NgModule, inject} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {Router, RouterModule} from '@angular/router';
import localeDE from '@angular/common/locales/de';
import {PortalService} from '../services/portal.service';
import {MinicheckComponent} from "./minicheck.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AdvisorSharedModule} from "../advisor.shared.module";
import {MatTabsModule} from "@angular/material/tabs";
import {MatExpansionModule} from "@angular/material/expansion";

declare let advisorPortal;

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  const http = inject(HttpClient);
  return {
    getTranslation: (lang: string) => http.get<object>('translations/' + (advisorPortal ?? PortalService.defaultPortal) + '/minicheck/' + lang + '.json')
  };
}

// load the locales dynamic, based on the users browser language with fallback
const browserLocale = getBrowsersLocale();
switch (browserLocale.substring(0, 2)) {
  case 'de':
    registerLocaleData(localeDE, 'de');
    break;
}

/**
 * returns the users locale from the browser
 */
function getBrowsersLocale() {
  /* tslint:disable:no-string-literal */
  if (navigator['browserLanguage']) {
    return navigator['browserLanguage'];
  }
  else if (navigator.language) {
    return navigator.language;
  }
  /* tslint:enable:no-string-literal */
}

@NgModule({
  declarations: [
    MinicheckComponent
  ],
  bootstrap: [
    MinicheckComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    AdvisorSharedModule,
    MatTabsModule,
    MatExpansionModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
        provideTranslateService({loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory}}),
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class MinicheckModule {
}
